import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import MediaDesc from './MediaDesc';
function MediaCheck(props) {
    const [open,setOpen] = useState(false)

    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bmj_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <MediaDesc
                    bmj_id={props.bmj_id}
                />            
            </Modal>
        </>
    )
}

export default MediaCheck